import { render, staticRenderFns } from "./SiteUpdateItem.vue?vue&type=template&id=53a82b6a&"
import script from "./SiteUpdateItem.vue?vue&type=script&lang=js&"
export * from "./SiteUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports